import store from '../../store';
import * as types from '../../actions/actionTypes';
import {setAssignQuoteCloneMode, toggleShowAssignQuotePopup} from '../../actions/assignPopupFunctions';
import {setNetworkConnection} from '../../actions/serverFunctions';
import {forceLoaderDisable, loaderDisable, loaderEnable} from '../../bvcomponents/ui/loaderView';

let recoveryPopupShown = false;
const fatalErrorSaveAsNewQuoteFlag = '__fatalErrorSaveAsNewQuote';

function closeMessageBox() {
  store.dispatch({
    type: types.CHANGE_MESSAGE_BOX,
    payload: {
      visible: false,
    },
  });
}

export function reloadWithQuote(jobId) {
  const url = new URL(window.location.href);

  url.searchParams.delete('quoteId');
  url.searchParams.delete('jobId');

  if (jobId) {
    // Hosted dashboard pages resolve `p` into document.kvConfig.jobId before React boots.
    // Keep jobId too so local dev can reload saved recovery quotes without backend HTML rendering.
    url.searchParams.set('p', jobId);
    url.searchParams.set('jobId', jobId);
  }

  const nextUrl = url.toString();

  if (nextUrl === window.location.href) {
    window.location.reload();
    return;
  }

  window.location.assign(nextUrl);
}

function saveCurrentQuote() {
  closeMessageBox();
  loaderEnable('loader.savingQuoteText');
  const {saveQuote} = require('../../api/server-api');

  saveQuote({
    submit: true,
    showReceipt: false,
  }).then((response) => {
    loaderDisable();
    reloadWithQuote(response && response.jobId);
  }).catch(() => {
    loaderDisable();
  });
}

function openSaveAsNewQuotePopup() {
  closeMessageBox();
  window[fatalErrorSaveAsNewQuoteFlag] = true;
  store.dispatch(setAssignQuoteCloneMode(true));
  store.dispatch(toggleShowAssignQuotePopup(true, 'save'));
}

export function shouldReloadAfterFatalErrorSaveAsNewQuote() {
  return window[fatalErrorSaveAsNewQuoteFlag] === true;
}

export function clearFatalErrorSaveAsNewQuoteReloadFlag() {
  window[fatalErrorSaveAsNewQuoteFlag] = false;
}

export function buildFatalErrorRecoveryMessageBoxState() {
  const hasSavedQuote = Boolean(document.kvConfig.jobId || store.getState().serverState.jobId);
  const buttons = hasSavedQuote
    ? [{
      text: 'messageBox.fatalErrorUpdateQuote',
      color: 'green',
      click: saveCurrentQuote,
    }, {
      text: 'messageBox.fatalErrorSaveAsNewQuote',
      color: 'blue',
      click: openSaveAsNewQuotePopup,
    }]
    : [{
      text: 'messageBox.fatalErrorSaveAsNewQuote',
      color: 'green',
      click: openSaveAsNewQuotePopup,
    }];

  return {
    visible: true,
    title: 'messageBox.fatalErrorTitle',
    message: hasSavedQuote
      ? 'messageBox.fatalErrorRecoveryText'
      : 'messageBox.fatalErrorUnsavedRecoveryText',
    error: true,
    newStyles: true,
    showCloseButton: true,
    closeClick: closeMessageBox,
    buttons,
  };
}


export function showFatalErrorRecoveryPopup() {
  if (recoveryPopupShown) {
    return;
  }

  recoveryPopupShown = true;
  setTimeout(() => {
    store.dispatch({
      type: types.CHANGE_MESSAGE_BOX,
      payload: buildFatalErrorRecoveryMessageBoxState(),
    });
  }, 0);
}

export function handleNetworkConnectionError() {
  setTimeout(() => {
    forceLoaderDisable();
    store.dispatch(setNetworkConnection(false));
  }, 0);
}
